import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AssetAuthService } from './asset-auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AssetAuthInterceptor implements HttpInterceptor {

  constructor(private assetAuthService: AssetAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept requests to the asset management API
    if (!req.url.startsWith(environment.assetApiUrl) && !req.url.startsWith(environment.assetBaseUrl)) {
      return next.handle(req);
    }

    // Get the auth token from the service
    const authToken = this.assetAuthService.getToken();

    // Clone the request and add the authorization header if token exists
    let authReq = req;
    if (authToken) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    // Handle the request and catch any auth errors
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // If we get a 401 Unauthorized, logout the user
        if (error.status === 401) {
          console.warn('Unauthorized request detected. Logging out user.');
          this.assetAuthService.logout();
        }
        
        return throwError(() => error);
      })
    );
  }
}